// The `referral` intake the share-the-care page writes: tracking only, never a contact.
// Its six keys are WF39's allowlist; the message is the text we prefilled, not what was sent.

export const REFERRAL_INTAKE_TYPE = 'referral';

export const REFERRAL_RELATIONSHIP_LABEL: Record<string, string> = {
  partner: 'Partner', parent: 'Parent', sibling: 'Sibling', friend: 'Friend', neighbor: 'Neighbor',
};

export const REFERRAL_CHANNEL_LABEL: Record<string, string> = {
  native: 'Share sheet', sms: 'Messages', whatsapp: 'WhatsApp', email: 'Email', copy: 'Copied message',
};

// "Partner · via Messages". Never echoes the message, which can carry a first name.
export function summarizeReferral(data: Record<string, unknown> | null | undefined): string {
  if (!data) return '';
  const who = REFERRAL_RELATIONSHIP_LABEL[String(data.relationship)];
  const via = REFERRAL_CHANNEL_LABEL[String(data.channel)];
  return [who, via ? `via ${via}` : ''].filter(Boolean).join(' · ');
}

interface IntakeLike { intake_type?: string | null }

// The collapsed list shows the newest clinical intakes; referrals fold into one line so a burst
// of invites can never push a red-flag symptom check out of view.
export function splitReferrals<T extends IntakeLike>(rows: T[], visible = 3): { shown: T[]; referrals: T[] } {
  const referrals = rows.filter((r) => r.intake_type === REFERRAL_INTAKE_TYPE);
  const shown = rows.filter((r) => r.intake_type !== REFERRAL_INTAKE_TYPE).slice(0, visible);
  return { shown, referrals };
}

export function invitesSharedLabel(n: number): string {
  return `${n} invite${n === 1 ? '' : 's'} shared`;
}
